export default __webpack_public_path__ + "static/media/dinnerKeto.905fd0a7.svg";